import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import NotificationActionLayout, { NotificationActionLayoutType } from '~/components/NotificationActionLayout/NotificationActionLayout';
import { handleRequest } from '~/infra/utils';
import { getApproveAmendmentContent } from '~/pages/NotificationAction/NotificationAction.utils';
import { useStoreActions } from '~/store/store-context';
export const GetApproveAmendmentActionTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            ApproveAmendmentActionTID: {
                Root: 'approve-amendment-action-page'
            }
        }
    });
const ApproveAmendmentAction = (param)=>{
    let { token, vendorName } = param;
    const { api } = useStoreActions();
    const [approveResultContent, setApproveResultContent] = useState();
    const [loading, setLoading] = useState(false);
    const { ApproveAmendmentActionTID } = useMemo(()=>GetApproveAmendmentActionTID(), []);
    async function sendApproveAmendmentsAction() {
        setLoading(true);
        const amendmentApproveResult = await handleRequest(api.relationship.approveAmendmentFromEmail({
            approvalToken: token
        }));
        const content = getApproveAmendmentContent({
            amendmentApproveResult,
            vendorName
        });
        setLoading(false);
        setApproveResultContent(content);
    }
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": ApproveAmendmentActionTID.Root(),
        children: /*#__PURE__*/ _jsx(NotificationActionLayout, {
            state: loading ? {
                type: NotificationActionLayoutType.Loading
            } : approveResultContent ? {
                type: NotificationActionLayoutType.AfterAction,
                afterAction: approveResultContent
            } : {
                type: NotificationActionLayoutType.BeforeAction,
                beforeAction: {
                    header: "Click the button below to approve the amendments to your agreement with ".concat(vendorName),
                    buttonText: 'Approve amendments',
                    onClick: sendApproveAmendmentsAction
                }
            }
        })
    });
};
export default ApproveAmendmentAction;
